module.exports = __webpack_public_path__ + "static/media/james.58bfb115.svg";